import { useEffect, useState } from "react";
import {normalizeCartGoods} from 'shared/lib/normalizers/normalizeGoods';


import { useDispatch } from "./useDispatch";
import { IGoodInCart } from "entities/products";
import { api } from "global/api";
import { setGoodsInCart } from "src/store/goods";
import { useSelector } from "./useSelector";

type Props = {
    withCountChange?: string | boolean;
    initialPrice: number;
    initialGoods: IGoodInCart[];
    initialWeight?: number;
    withGoodsUpdate?: boolean
}

export const useCartList = ({ initialGoods, withGoodsUpdate = true, initialPrice, withCountChange, initialWeight = 0 }: Props) => {
    const [orderPrice, setOrderPrice] = useState(initialPrice);
    const [basketChanged, setBasketChanged] = useState(withCountChange);
    const [weight, setWeight] = useState(initialWeight)
    const [isCheckoutDisabled, setIsCheckoutDisabled] = useState(false);
    const goodsList = useSelector((state) => state.goods.goodsInCart);
    const dispatch = useDispatch();



    useEffect(() => {
        withGoodsUpdate && dispatch(setGoodsInCart(initialGoods.map((good) => ({ ...good, isChecked: true, isRemoved: false }))));
    }, [initialGoods]);

    const handleChangeGood = (products: IGoodInCart[]) => {

        dispatch(setGoodsInCart(products));

    };

    useEffect(() => {

        const { price, weight } = goodsList.reduce<{ price: number, weight: number }>(
            (acc, good) =>
                good.isRemoved || !good.isChecked
                    ? acc
                    : { price: acc.price + good.product.price * good.quantity, weight: acc.weight + good.product.product_weight * good.quantity / 1000 },
            { price: 0, weight: 0 }
        );

        setOrderPrice(() => price);
        setWeight(() => weight)
    }, [goodsList])


    const handleError = async () => {
        let initialGoods = [];
        let initialPrice = 0;
        let withCountChange = '';

        try {
            const cartRes = await api.getCart();
            const cart = cartRes.data.data;

            initialPrice = cart.order_price / 100;
            initialGoods = normalizeCartGoods(cart.products);

            if (cart.basket_changed) {
                withCountChange = cart.basket_changed;
            }
        } catch (error) {
            console.error(error);
        }

        dispatch(setGoodsInCart(initialGoods));
        setOrderPrice(initialPrice);
        setBasketChanged(withCountChange);
    };
    return {
        orderPrice,
        goodsList,
        basketChanged,
        isCheckoutDisabled,
        setIsCheckoutDisabled,
        handleChangeGood,
        handleError,
        setOrderPrice,
        weight,
        setWeight,
    }
}